import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { getTrialEligibility } from "@/services/unsaidService";

export const fmtDate = (d) => new Date(d).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" });

// The active consumer offer for this account, decided and worded by the server (checkout enforces it again).
// undefined while loading, null if unavailable, else { key, eligible, today, eyebrow, headline, cta, terms[] }.
export const useTrialEligibility = () => {
  const [offer, setOffer] = useState(undefined);
  useEffect(() => { getTrialEligibility().then(setOffer); }, []);
  return offer;
};

const Item = ({ children }) => (
  <li className="flex gap-2"><ShieldCheck className="mt-0.5 h-4 w-4 shrink-0 text-teal-600" /> <span>{children}</span></li>
);

export const TrialTerms = ({ offer, className = "" }) => {
  if (!offer) {
    return offer === null ? (
      <p className={`text-center text-sm text-slate-600 ${className}`} data-testid="billing-terms-unavailable">
        We couldn't load the current pricing. Please refresh to see the exact terms before subscribing.
      </p>
    ) : null;
  }
  return (
    <div className={className} data-testid="billing-terms" data-offer={offer.key} data-eligible={String(offer.eligible)}>
      <p className="text-center text-base font-semibold text-slate-900" data-testid="billing-terms-headline">{offer.headline}</p>
      <ul className="mt-4 space-y-2 text-sm leading-relaxed text-slate-600">
        {offer.terms.map((t, i) => <Item key={i}>{t}</Item>)}
      </ul>
    </div>
  );
};
